import axios from "../config/axios";


export const MailApiRepository = {
  contactUs: ({name, phone, email, company, volume, message}) =>
    axios.post("/api/mail/contact-us", {name, phone, email, company, volume, message}),
}
